<template>
  <v-layout
    class="white"
    align-space-between
    justify-start
    column
    fill-height
  >
    <v-flex
      shrink
      class="sz_background_light"
      py-3
    >
      <v-flex
        md10
        offset-md1
        sm12
        offset-sm0
      >
        <v-layout
          class="header none-growth"
          align-center
        >
          <v-flex shrink>
            <AppLogo width="60" />
          </v-flex>
          <v-flex ml-5>
            <h1 class="display-4">
              {{ pageTitle }}
            </h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-flex>
    <v-flex v-if="isLoading === false && isLoadingResource === false">
      <WarehouseData
        v-if="isRegional"
        :edit-mode="editMode"
      />
      <SupportingWarehouseData
        v-else
        :edit-mode="editMode"
      />
    </v-flex>
    <LeaveConfirmDialog ref="confirm" />
  </v-layout>
</template>

<script>
import WarehouseData from '@/components/warehouse/WarehouseData';
import LeaveConfirmDialog from '@/components/widgets/LeaveConfirmDialog';
import AppLogo from '@/components/widgets/AppLogo';
import SupportingWarehouseData from '@/components/warehouse/SupportingWarehouseData';

export default {
    name: 'AddWarehouse',
    components: { SupportingWarehouseData, AppLogo, LeaveConfirmDialog, WarehouseData },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            if (vm.isRegional) {
                const selectedProvinceId = vm.$store.getters['warehouses/getSelectedRejon'].id;
                vm.isLoading = true;
                vm.$store.dispatch('warehouses/existRejonWarehouse', selectedProvinceId).then(() => {
                    if (vm.$store.getters['warehouses/getRejonHasWarehouse']) {
                        vm.$store
                            .dispatch('warehouses/getWarehousesPerLocation', selectedProvinceId)
                            .finally(() => {
                                vm.isLoading = false;
                            });
                    } else {
                        vm.$store.dispatch('warehouses/getWarehouseDraft', selectedProvinceId).finally(() => {
                            vm.isLoading = false;
                        });
                    }
                });
            } else {
                const provinceId = vm.$store.getters['warehouses/getSelectedProvince'].province_id;
                vm.$store.commit('warehouses/setShowDraftButton', true);
                vm.$store.dispatch('warehouses/getSupportingWarehouseDraft', provinceId).finally(() => {
                    vm.isLoadingDraft = false;
                    if (Object.prototype.hasOwnProperty.call(vm.$route.params, 'warehouseId')) {
                        vm.isLoading = true;
                        const warehouseId = vm.$route.params.warehouseId;
                        vm.$store
                            .dispatch('warehouse/getWarehouse', {
                                warehouseId,
                                isForm: true
                            })
                            .then(() => {
                                vm.$store.commit('warehouses/setShowDraftButton', false);
                            })
                            .finally(() => {
                                vm.isLoading = false;
                            });
                    } else {
                        vm.isLoading = false;
                    }
                });
            }
        });
    },
    beforeRouteLeave (from, to, next) {
        if (this.isFieldsChanged && !this.$store.getters['token/isForcedToLogout']) {
            this.$refs.confirm.dialog = true;
            this.$refs.confirm.open().then((confirm) => {
                if (confirm) {
                    Object.keys(this.$validator.flags).forEach((x) => {
                        this.$validator.flags[x].changed = false;
                    });
                    this.$store.dispatch('warehouses/clearAddWarehouseData');
                    this.$store.dispatch('warehouses/clearAddSupportingWarehouseData');
                    this.$store.dispatch('warehouses/removeLocalIdFromStorage', 1);
                    next();
                } else {
                    next(false);
                }
            });
        } else {
            this.$store.dispatch('warehouses/clearAddWarehouseData');
            this.$store.dispatch('warehouses/clearAddSupportingWarehouseData');
            this.$store.dispatch('warehouses/removeLocalIdFromStorage', 1);
            next();
        }
    },
    data () {
        return {
            isLoading: null,
            isLoadingResource: null
        };
    },
    computed: {
        title () {
            return this.editMode
                ? this.$t('warehouses.add_rejon_warehouse.edit_title')
                : this.$t('warehouses.add_rejon_warehouse.title');
        },
        pageTitle () {
            if (this.previewMode) {
                return this.$t('warehouses.preview.title');
            }
            return this.title + ': ' + this.$t('warehouses.stepper.data');
        },
        editMode () {
            return (
                this.$route.name === 'edit-warehouse-data' ||
        this.$route.name === 'edit-supporting-warehouse-data'
            );
        },
        previewMode () {
            return !this.$route.name.includes('warehouse-data');
        },
        isRegional () {
            return !this.$route.name.includes('supporting');
        },
        isFieldsChanged () {
            return Object.keys(this.fields).some((key) => this.fields[key].changed);
        }
    },
    created () {
        window.addEventListener('beforeunload', (event) => {
            if (this.isFieldsChanged) {
                event.returnValue = window.confirm(this.$t('message.leave_confirmation'));
            }
        });

        const resourceId = this.isRegional ? 3 : 4;
        this.$store.dispatch('warehouses/loadResource', resourceId).then(() => {
            this.isLoadingResource = false;
        });

        if (this.$store.getters['warehouses/getSelectedRejon'] === null) {
            const storageId = this.isRegional ? 1 : 2;
            this.$store.dispatch('warehouses/getLocalIdFromLStorage', storageId);
        }
    }
};
</script>

<style scoped></style>
